export default __webpack_public_path__ + "static/media/transit_stop_marker.01b973e3.svg";